<template>
  <div class="area background">
    <div class="text">
      <h1>
        Deep learning based tracking of muscle tendon junctions
      </h1>
      <h3>
        deepMTJ is an open-source tool for tracking muscle-tendon
        junctions in ultrasound images based on DNNs. It is designed as a simple, yet
        comprehensive interface to assist biomechanics and clinical gait
        researchers in their data evaluation process.
      <br>
      </h3>
      <div>
        <button @click="$emit('increaseCurrentStep')" class="buttonOnline">
          Predict online
        </button>
      </div>
      <h3>
        Use our Google Colab workspace for unrestricted predictions:
        <div>
          <a href="https://colab.research.google.com/github/luuleitner/deepMTJ/blob/master/mtj_tracking/predict/mtj_tracking.ipynb"
            target="_blank"
            @click="this.report_visit_workspace"
          >
            <button class="buttonWorkspace">
              Go to workspace
            </button>
          </a>
        </div>
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "Start.vue",

  methods: {
    report_visit_workspace() {
      this.$gtag.event("visit_workspace", { method: "Google" });
    },
    report_start() {
      this.$gtag.event("session_start", { method: "Google" });
    },
    created() {
      this.report_start();
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/styling.css";

.buttonOnline {
  content: "Select files";
  display: inline-block;
  /*background: linear-gradient(top, #f9f9f9, #e3e3e3);*/
  background: #2554c7;
  border: 0px solid #999;
  border-radius: 10px;
  margin-top: 22px;
  margin-bottom: 20px;
  padding: 30px 60px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  /*text-shadow: 1px 1px #fff;*/
  /*font-weight: 700;*/
  font-size: 24pt;
  font-family: Helvetica;
  color: #fff;
}

.buttonWorkspace {
  content: "Select files";
  display: inline-block;
  /*background: linear-gradient(top, #f9f9f9, #e3e3e3);*/
  background: #2554c7;
  border: 0px solid #999;
  border-radius: 10px;
  margin-top: 22px;
  padding: 15px 30px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  /*text-shadow: 1px 1px #fff;*/
  /*font-weight: 700;*/
  font-size: 20pt;
  font-family: Helvetica;
  color: #fff;
}

h1 {
  margin-top: 3vw;
}

h3 {
  margin-top: 30px;
}
</style>
